import { useProducts } from './use-products';
import { useSavingsCalculator } from './use-savings-calculator';
import { useCalculate } from './use-calculate';
import { LabelsType, ProductType, SavingsCalculatorStateType } from '../types';
import { getLabel } from '../labels';

type Props = {
    initialValues: SavingsCalculatorStateType | null;
    labels: LabelsType;
    hiddenProducts?: string[];
    productOrder?: string[];
};

const DEFAULT_STATE_VALUES = {
    startAmount: 0,
    monthlyDeposit: 2500,
    years: 15,
    annualInterestRate: null,
    customInterestRate: '',
};

export const useSavingsGrowthGraphCalculator = ({ initialValues, labels, hiddenProducts = [], productOrder = [] }: Props) => {
    const { products, chosenProduct, setChosenProduct, productsLoading } = useProducts({ hiddenProducts, productOrder });
    const { savingsCalculatorState, updateSavingsCalculatorState } = useSavingsCalculator({
        ...(initialValues || DEFAULT_STATE_VALUES),
        chosenProduct,
    });
    const { futureTotalValue, totalDeposits, totalInterestEarned, graphData } = useCalculate(savingsCalculatorState, chosenProduct);

    const formatNumber = (number: number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');

    const getLabelCallback = (key: keyof LabelsType, replacements?: Record<string, string | number>) => getLabel(labels, key, replacements);

    return {
        products,
        chosenProduct,
        setChosenProduct: (product: ProductType | null) => {
            updateSavingsCalculatorState({ customInterestRate: '' });
            setChosenProduct(product);
        },
        productsLoading,

        savingsCalculatorState,
        updateSavingsCalculatorState,

        futureTotalValue,
        totalDeposits,
        totalInterestEarned,
        graphData,

        formatNumber,
        getLabelCallback,
    };
};
